import(/* webpackMode: "eager" */ "/home/runner/work/joydrop-ui/joydrop-ui/src/app/home/page.tsx");
